import OrderCouponPopup from './order-coupon-popup.vue';

export default OrderCouponPopup;